module.exports = __webpack_public_path__ + "img/role-develop-guides.7b077c86.png";